// extracted by mini-css-extract-plugin
module.exports = {"applications-wrapper":"Applications_applications-wrapper__1daj4"};